import * as v from "valibot";
import { baseVals, defineValidation, validations } from "../../common/validation.common";
import { RadiusProfileCommonSchema } from "../radius_profile/radius_profile.request";

export namespace ProductDedicatedValidation {
    export const Update = defineValidation(
        v.object({
            name: v.exactOptional(baseVals.string()),
            price: v.exactOptional(baseVals.intMin(10_000, "Harga")),
            vlanId: v.exactOptional(baseVals.intRange(10, 4080, "VLAN ID")),
            radiusProfile: v.exactOptional(RadiusProfileCommonSchema.create),
        }),
    );

    export const Remove = defineValidation(
        v.object({
            vlanId: validations.deletable,
        }),
    );
}
